import React from 'react';
import type { FC } from 'react';
import { match, constant } from 'variant';
import type { Site } from '@wix/site-list-client';
import { Alert, useExit } from '@wix/cli-ui-kit';
import { useTranslation } from '@wix/cli-i18n';
import { SiteSelector } from '@wix/cli-site-selector';
import { useBiLogger } from '@wix/cli-telemetry-react';
import { useProjectModel } from '../model.js';
import type { SiteState } from './site-state.js';

interface Props {
  state: SiteState<'NotConfigured' | 'NotFound'>;
  onSubmit: (site: Site) => void;
}

export const ResolveSite: FC<Props> = ({ state, onSubmit }) => {
  const exit = useExit();
  const { t } = useTranslation();
  const { model } = useProjectModel();
  const biLogger = useBiLogger();

  return (
    <>
      {match(state, {
        NotConfigured: constant(
          <Alert type="insight">{t('general.no_site_id_configured')}</Alert>
        ),
        NotFound: ({ id }) => (
          <Alert type="error">{t('general.site_id_not_found', { id })}</Alert>
        ),
      })}
      <SiteSelector
        appId={model.config.appId}
        biLogger={biLogger}
        onSubmit={onSubmit}
        onError={exit}
      />
    </>
  );
};
